// extracted by mini-css-extract-plugin
export var characteristicsImg_container = "DetailsOutstanding-module--characteristicsImg_container--61b9e";
export var characteristics_container = "DetailsOutstanding-module--characteristics_container--fee27";
export var detailsOutstanding__container = "DetailsOutstanding-module--detailsOutstanding__container--be078";
export var featured_img = "DetailsOutstanding-module--featured_img--0aa60";